import React, { useState, useEffect } from 'react';
import api from '../api/client';
import './HistoryPopup.css';

const HistoryPopup = ({  isOpen, 
    endpoint, 
    queryParams, 
    columns, 
    onClose }) => {
    const [historyData, setHistoryData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    

    useEffect(() => {
        const fetchHistory = async () => {
            try {
                const response = await api.get(
                    `${endpoint}?${queryParams}`
                );
                setHistoryData(response.data);
            } catch (err) {
                console.error('Error fetching history data:', err);
                setError('Failed to load history');
            } finally {
                setLoading(false);
            }
        };

        fetchHistory();
    }, [isOpen, endpoint, queryParams]);

    if (loading) return <div className="history-popup">Loading...</div>;
    if (error) return <div className="history-popup">Error: {error}</div>;

    return (
        <div className={`history-popup ${isOpen ? 'active' : ''}`}>
            <div className="history-popup-header">

                <button className="popup__close-button" onClick={onClose}>
                        {/* <svg
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <use xlinkHref="#closeBtn"></use>
                        </svg> */}
                        ✖

                    </button>
            </div>
            <table className="history-table">
                <thead>
                    <tr>
                    {columns.map((col) => (
                            <th key={col.key}>{col.label}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                {historyData.map((entry, index) => (
                        <tr key={index}>
                            {columns.map((col) => {
                                const value = entry[col.key];
                                return (
                                    <td key={col.key}>
                                        {col.type === 'datetime' 
                                            ? new Date(value).toLocaleString() 
                                            : col.type === 'date'
                                            ? new Date(value).toLocaleDateString()
                                            : value}
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default HistoryPopup;